/**
 * Generated bundle index. Do not edit.
 */

export {TruncatePipesModule} from './public_api';

export {CharactersPipe as ɵa} from './src/pipes/characters.pipe';
export {SplitcharactersPipe as ɵb} from './src/pipes/splitcharacters.pipe';
export {WordsPipe as ɵc} from './src/pipes/words.pipe';